import { displaySettingsSelector } from '../../reducers/display-settings-selectors';

import { LocalStorageController } from '../../util/local-storage-controller';
import { DISPLAY_SETTINGS_KEY } from '../../util/local-storage-keys';

// The state here should be the state of the entire redux store but we don't have that typed currently
export const saveDisplaySettings = (state: any) => {
  LocalStorageController.setItem(
    DISPLAY_SETTINGS_KEY,
    JSON.stringify(displaySettingsSelector(state)),
  );
};
